import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import styles from "./Notification.scss";

export type NotificationHeadlineProps = React.ComponentPropsWithRef<"p">;

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
export const NotificationHeadline = forwardRef<
  HTMLParagraphElement,
  NotificationHeadlineProps
>(({ children, ...restProps }, ref) => (
  <p ref={ref} className={styles.headline} {...restProps}>
    {children}
  </p>
));

NotificationHeadline.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

NotificationHeadline.displayName = "Notification.Headline";

export default NotificationHeadline;
